import { useState } from 'react';
import { Browser } from '@capacitor/browser';
import { useTranslation } from 'react-i18next';
import { useAppUpdate } from '../hooks/useAppUpdate';

// UI del pull "Aggiorna l'app" (solo nativo — su web l'hook ritorna sempre false → non rende nulla).
// - updateRequired → overlay BLOCCANTE (nessuna chiusura): la build è sotto la minSupportedVersion.
// - updateAvailable → banner in alto, non bloccante e chiudibile per la sessione.
const AppUpdateGate = () => {
    const { t } = useTranslation();
    const { updateAvailable, updateRequired, storeUrl } = useAppUpdate();
    const [dismissed, setDismissed] = useState(false);

    const openStore = () => {
        if (storeUrl) Browser.open({ url: storeUrl });
    };

    // Blocco totale: prioritario sul banner, non dismissibile
    if (updateRequired) {
        return (
            <div
                style={{
                    position: 'fixed',
                    inset: 0,
                    zIndex: 9995, // sopra status bar backdrop (9990), sotto il badge LOCALE (9999)
                    background: '#ffffff',
                    paddingTop: 'max(env(safe-area-inset-top), 20px)',
                }}
                className="flex flex-col items-center justify-center gap-6 px-8 text-center"
            >
                <div className="w-20 h-20 rounded-full bg-[#225424] flex items-center justify-center">
                    <i className="fi fi-rr-refresh text-3xl text-white pt-1"></i>
                </div>
                <h2>{t('AppUpdate.requiredTitle')}</h2>
                <p className="text-neutral-500">{t('AppUpdate.requiredBody')}</p>
                <button className="bg-[#225424] py-3 px-6 text-white rounded-xl w-full md:w-fit" onClick={openStore}>
                    {t('AppUpdate.action')}
                </button>
            </div>
        );
    }

    if (!updateAvailable || dismissed) return null;

    return (
        <div
            style={{
                position: 'fixed',
                top: 'max(env(safe-area-inset-top), 20px)',
                left: 0,
                right: 0,
                zIndex: 9985, // sotto la status bar backdrop, sopra navbar e contenuto
                paddingLeft: 'max(env(safe-area-inset-left), 12px)',
                paddingRight: 'max(env(safe-area-inset-right), 12px)',
            }}
            className="px-3 pt-2"
        >
            <div className="w-full bg-[#225424] text-white rounded-xl shadow-lg px-4 py-3 flex items-center gap-3">
                <i className="fi fi-rr-refresh text-xl pt-1"></i>
                <div className="flex-grow text-sm">
                    <div className="font-bold">{t('AppUpdate.bannerTitle')}</div>
                    <div className="opacity-90">{t('AppUpdate.bannerBody')}</div>
                </div>
                <button className="bg-white text-[#225424] font-bold text-sm py-1.5 px-3 rounded-lg whitespace-nowrap" onClick={openStore}>
                    {t('AppUpdate.action')}
                </button>
                <button aria-label={t('AppUpdate.dismiss')} className="pl-1" onClick={() => setDismissed(true)}>
                    <i className="fi fi-rr-cross-small text-xl"></i>
                </button>
            </div>
        </div>
    );
};

export default AppUpdateGate;
